export const orderItemRemarksTemplateCategory = 'order-item-remarks_template'
export const salesOrderCommunicationTemplateCategory = 'chat_template'
